import { Play, RotateCcw, Trash2, type LucideIcon } from 'lucide-react';

interface GetBulkCourseActionsProps {
  onBulkStart: () => void;
  onBulkStop: () => void;
  onBulkDelete: () => void;
}

export interface BulkCourseAction {
  title: string;
  icon: LucideIcon;
  onClick: () => void;
  className: string;
}

export const BULK_ACTION_BUTTON_CLASS =
  'inline-flex items-center gap-1.5 p-2 text-xs font-medium rounded-full! transition-colors cursor-pointer';
export const BULK_ACTION_ICON_CLASS = 'w-4 h-4';

export const getBulkCourseActions = ({
  onBulkStart,
  onBulkStop,
  onBulkDelete,
}: GetBulkCourseActionsProps): BulkCourseAction[] => [
  {
    title: 'Start selected courses',
    icon: Play,
    onClick: onBulkStart,
    className: 'bg-(--success-S300) text-(--success-S700) hover:bg-(--success-S400)',
  },
  {
    title: 'Reset selected courses',
    icon: RotateCcw,
    onClick: onBulkStop,
    className: 'bg-(--warning-W300) text-(--warning-W700) hover:bg-(--warning-W400)',
  },
  {
    title: 'Remove selected courses',
    icon: Trash2,
    onClick: onBulkDelete,
    className: 'bg-(--danger-D300) text-(--danger-D700) hover:bg-(--danger-D400)',
  },
];
